import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import {SlideDown} from 'react-slidedown'
import convert from '../../helpers/convert'
import {
  LinkIcon,
  CompanyProfileModal,
} from '../'
import Styles from './ScreenedCompanies.css'


@CSSModules(Styles, {allowMultiple: true})
export default class ScreenedCompanies extends Component {
  static propTypes = {
    companyList: PropTypes.array,
  }

  constructor(props){
    super(props)
    const prisonsCompanies = []
    const bordersCompanies = []
    this.state = {
      prisonsViewMore: false,
      bordersViewMore: false,
      prisonsCompanies,
      bordersCompanies
    }
  }

  componentWillReceiveProps(props){
    if (props.companyList) {
      const prisonsCompanies = []
      const bordersCompanies = []
      const devnull = props.companyList.map((el)=>{
        if (el.is_pp) prisonsCompanies.push(el)
        if (el.is_borders) bordersCompanies.push(el)
        return false
      })
      // SORTING IS NOW IN THE API CALL
      // const _sorter = (a, b)=>{
      //   const lbl = 'short_name'
      //   const a_s = a[lbl].toLowerCase()
      //   const b_s = b[lbl].toLowerCase()
      //   return a_s.localeCompare(b_s)
      // }
      // prisonsCompanies = prisonsCompanies.sort(_sorter)
      // bordersCompanies = bordersCompanies.sort(_sorter)
      this.setState({
        prisonsCompanies,
        bordersCompanies
      })
    }
  }
  
  clickViewMore = (lbl) =>{
    const stateLbl = lbl + 'ViewMore'
    const newState = {}
    newState[stateLbl] = !this.state[stateLbl]
    this.setState(newState)
  }

  renderButton = (lbl, lbls) => {
    const viewMore = this.state[lbl + 'ViewMore']
    const companies = this.state[lbl + 'Companies']

    const high = (
      <span styleName='high-icon'>
        <LinkIcon faclass='fa-exclamation-triangle' nospace/>
      </span>
    )
    const extreme = (
      <span styleName='extreme-icon'>
        <LinkIcon faclass='fa-exclamation-triangle' nospace/>
      </span>
    )

    return (
      <div styleName='btn-tbl-wrp'>
        <button
          styleName='view-more'
          onClick={()=>{ this.clickViewMore(lbl) }}
          title={lbls[lbl]}
        >
          {lbls[lbl]}
          <LinkIcon
            faclass={(viewMore)?'fa-angle-up':'fa-angle-down'}
          />
        </button>
        <SlideDown>
          { 
            viewMore ?
              (
                <div>
                  <div styleName='detail-holdings-info-text'>
                    <strong>Key:</strong>
                    <br/>
                    {high} <em>Higher risk</em>
                    <br/>
                    {extreme} <em>Private prison operators</em>
                  </div>
                  <table styleName='t-table'>
                    <thead>
                      <tr>
                        <th>Company</th>
                        <th>Symbol</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        companies.map((c, i)=>{
                          const isHigh = convert.boolean(c.is_pff_high)
                          const isExtreme = convert.boolean(c.is_pff_extreme)
                          let icn = null
                          let stl = 'company-td'
                          if (isExtreme) {
                            icn = extreme
                            stl += ' bred'
                          } else if (isHigh) {
                            icn = high
                            stl += ' bold'
                          }
                          return (
                            <tr key={'to_'+i}>
                              <td styleName={stl}>
                                <CompanyProfileModal companyProfile={c} >
                                  {c.short_name}
                                </CompanyProfileModal>
                              </td>
                              <td styleName={stl}>{c.primary_symbol}</td>
                              <td>{icn}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
              ) : 
              null
          }
        </SlideDown>
      </div>
    )
  }

  render() {
    if (!this.props.companyList) {
      return (
        <div styleName="main">
          <Loader
            options={{scale: 0.70, top:'4.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const labels = {
      prisons: (!this.state.gmViewMore ? 'View prison industry companies' : 'View less'),
      borders: (!this.state.grViewMore ? 'View border industry companies' : 'View less')
    }

    const icons = {
      prisons: require( '../../../static/images/icn-pp.svg' ),
      borders: require( '../../../static/images/icn-borders.svg' )
    }

    return (
      <div styleName='main-wrap'>

        <div styleName='screen-card'>
          <div styleName='screen-bullet'>
            <img
              styleName='screen-icon'
              alt='Prisons'
              src={icons.prisons}
            />
            <div styleName='screen-icon-label'>
              <p>
                <span styleName='bold'>Prison industry</span> &mdash;  The prison industry in the United States is massive and growing, with the U.S. prison population the largest in the world, both per capita and in total numbers. The prison industry screen flags companies involved in incarceration and detention facilities (including facility management, youth and family detention, private facilities internationally, private prison financing, transportation and deportations, facility surveillance and security, and prison labor), services in facilities (including communication services, health services, banking and financial services, and food, commissary, and other goods), and supervision and monitoring (including e-carceration, community corrections, and bail bonds).
              </p>
            </div>
          </div>
          {this.renderButton('prisons', labels)}
        </div>

        <div styleName='screen-card'>
          <div styleName='screen-bullet'>
            <img
              styleName='screen-icon'
              alt='Borders'
              src={icons.borders}
            />
            <div styleName='screen-icon-label'>
              <p>
                <span styleName='bold'>Border industry</span> &mdash; The border industry has been similarly growing, with the advent of private policing and the development of virtual border, surveillance, and monitoring technologies. The border industry screen flags companies involved in incarceration and detention facilities (including facility management, youth and family detention, private prison financing, facility surveillance and security, transportation and deportations, and prison labor), militarization of the U.S.-Mexico border (including border construction and maintenance and border monitoring and surveillance), and immigrant monitoring and surveillance (including high-tech surveillance of immigrants, e-carceration, and bail bonds).
              </p>
            </div>
          </div>
          {this.renderButton('borders', labels)}
        </div>
      </div>
    )
  }
}

